import Home from "../views/Home";
import Contacts from "../views/Contacts";
import Projects from "../views/Projects";
import Dzintars from "../views/projects/Dzintars";
import About from "../views/About";
import Lnb from "../views/projects/Lnb";
import LnbInfrastructure from "../views/projects/LnbInfrastructure";
import Ventspils from "../views/projects/Ventspils";
import ZTowers from "../views/projects/ZTowers";
import Private from "../views/projects/Private";
import TvTower from "../views/projects/TvTower";
import TV3 from "../views/projects/TV3";
import Proposals from "../views/projects/Proposals";

export default [
	{
		path: '/',
		component: Home,
		alias: ['', '/ru', '/en'],
	},
	{
		path: '/contacts',
		component: Contacts,
		alias: ['/ru/contacts', '/en/contacts'],
	},
	{
		path: '/projects',
		component: Projects,
		alias: ['/en/projects', '/ru/projects'],
	},
	{
		path: '/projects/dzintars',
		component: Dzintars,
		alias: ['/en/projects/dzintars', '/ru/projects/dzintars'],
	},
	{
		path: '/projects/lnb',
		component: Lnb,
		alias: ['/en/projects/lnb', '/ru/projects/lnb'],
	},
	{
		path: '/projects/lnb-infrastructure',
		component: LnbInfrastructure,
		alias: ['/en/projects/lnb-infrastructure', '/ru/projects/lnb-infrastructure'],
	},
	{
		path: '/projects/ventspils',
		component: Ventspils,
		alias: ['/en/projects/ventspils', '/ru/projects/ventspils'],
	},
	{
		path: '/projects/z-towers',
		component: ZTowers,
		alias: ['/en/projects/z-towers', '/ru/projects/z-towers'],
	},
	{
		path: '/projects/private',
		component: Private,
		alias: ['/en/projects/private', '/ru/projects/private'],
	},
	{
		path: '/projects/tv-tower',
		component: TvTower,
		alias: ['/en/projects/tv-tower', '/ru/projects/tv-tower'],
	},
	{
		path: '/projects/tv3',
		component: TV3,
		alias: ['/en/projects/tv3', '/ru/projects/tv3'],
	},
	{
		path: '/projects/proposals',
		component: Proposals,
		alias: ['/en/projects/proposals', '/ru/projects/proposals']
	},
	{
		path: '/about',
		component: About,
		alias: ['/en/about', '/ru/about'],
	},
	{
		path: '*',
		redirect: '/'
	},
]